import { BaseQueryParams } from '../common/models/base-query-params';
import { CityResponse } from '../common/models/city';
import { Paginated } from '../common/models/paginated';
import { buildBasicPaginatedSearchParams } from '../common/utils/url-search-params.helper';
import { apiPaths } from '../config/apiPaths';
import axiosInstance from './axios';

export const getCities = async ({
  page,
  limit,
  countryId,
}: BaseQueryParams & { countryId?: string }): Promise<Paginated<CityResponse>> => {
  let additionalParams: Map<string, string> | undefined = undefined;
  if (countryId) {
    additionalParams = new Map([['countryId', countryId]]);
  }
  const searchParams = buildBasicPaginatedSearchParams(page, limit, undefined, additionalParams);
  const { data } = await axiosInstance.get<Paginated<CityResponse>>(apiPaths.CITIES_PATH, {
    params: searchParams,
  });
  return data;
};
